import request from '@/utils/request'

export function openLogin(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/imposition/selectCompleteFile?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}
export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/imposition/bathDeleteFile`,
        method: 'post',
        data,
    })
}

export function downLoad(data) {
    return request({
      headers: { "contentType" : "application/json;charsetset=UTF-8"},
      responseType: "blob" ,
        url: `api/serviceCenter/imposition/downLoad`,
        method: 'post',
        data,
    })
}

export function noticeImposition(data,param) {
  return request({
    headers: { "contentType" : "application/json;charsetset=UTF-8"},
      url: `api/serviceCenter/imposition/noticeImposition?param=${param}`,
      method: 'post',
      data,
  })
}

export function downLoadComplete(data) {
  return request({
    headers: { "contentType" : "application/json;charsetset=UTF-8"},
    responseType: "blob" ,
      url: `api/serviceCenter/imposition/downLoadComplete?access=${data}`,
      method: 'post',
  })
}
export default {
    //   下载关键代码
      download(url, params) {
        return new Promise((resolve, reject) => {
            axios({
            //   和后端协商好下载方法post/get?
            method: 'Post',
            url: baseUrl + url,
            data: params,
            headers: {
                'Content-Type': 'application/json',
                // 设置请求头携带的token
              token: JSON.parse(localStorage.getItem('userInfo')).token,
            },
            responseType: 'blob',
          })
            .then((res) => {
              console.log(res);
              const fileName = res.headers['content-disposition'].split('filename=')[1];
              const response = res.data;
              const r = new FileReader();
              r.onload = () => {
                try {
                  const resData = JSON.parse(this.result);
                  if (resData) {
                    if (resData.error_no === undefined) {
                      throw new Error('解析成功！');
                    } else if (resData.error_no !== '0') {
                      Message({
                        message: resData.error_info || 'Error',
                        type: 'error',
                        duration: 5 * 1000,
                      });
                    }
                  }
                } catch (err) {
                  // 兼容ie11
                  if (window.navigator.msSaveOrOpenBlob) {
                    try {
                      const blobObject = new Blob([response]);
                      window.navigator.msSaveOrOpenBlob(blobObject, fileName);
                    } catch (e) {
                      console.log(e);
                      reject(e);
                    }
                    return;
                  }
                  const url = window.URL.createObjectURL(new Blob([response]));
                  const link = document.createElement('a');
                  link.style.display = 'none';
                  link.href = url;
                  link.setAttribute('download', fileName);
                  document.body.appendChild(link);
                  link.click();
                }
              };
              r.readAsText(response);
              resolve();
            })
            .catch((error) => {
              console.log(error);
              Message({
                message: '下载失败！',
                type: 'error',
                duration: 5 * 1000,
              });
              reject(error);
            });
        });
      },
    };

